'use client';

import type { ValidatedCustomerReportDataV3 } from '@dte/otw-azure-functions/src/report/CustomerReport';
import { atom, useAtomValue } from 'jotai';
import { storedDraftDataAtom } from './_atoms/draftReport/draftReportAtoms';

export const validatedDraftReportAtom = atom((get) => {
	const storedDraftResponse = get(storedDraftDataAtom);

	// Use the submitted report (if we've already submitted)
	const submittedReport = storedDraftResponse?.submittedReport?.data;
	const draftReport = storedDraftResponse?.draftReport?.validatedReport;

	return submittedReport ?? draftReport;
});
validatedDraftReportAtom.debugLabel = 'validatedDraftReport';

export function useValidatedReport(): ValidatedCustomerReportDataV3 | undefined {
	return useAtomValue(validatedDraftReportAtom);
}

const projectedCallCodeAtom = atom((get) => {
	const report = get(validatedDraftReportAtom);
	return report?.problem?.callCode;
});
projectedCallCodeAtom.debugLabel = 'projectedCallCodeAtom';

export function useProjectedCallCode(): string | undefined {
	return useAtomValue(projectedCallCodeAtom);
}
